// React
import React from "react";

// Components
import { StreamLayoutCanvasInner } from "../StreamLayoutCanvasInner/StreamLayoutCanvasInner";

// Types
import { Background, Logo, StudioTemplate } from "../../features/api/apiSlice";
import { StudioLayout } from "../../pages/StreamLayoutPage/StreamLayoutPage";

interface StreamPreviewProps {
  className?: string;
  currentTemplate?: StudioTemplate;
  background?: Background;
  layout?: StudioLayout;
  logo?: Logo;
}

export const StreamPreview: React.FC<StreamPreviewProps> = ({
  className,
  currentTemplate,
  background,
  layout,
  logo
}) => {
  return (
    <StreamLayoutCanvasInner
      className={className}
      currentTemplate={currentTemplate}
      background={background}
      layout={layout}
      logo={logo}
      showLocalTracks={true}
    />
  );
};

export default StreamPreview;